import React, { Component } from 'react';

import PropTypes from 'prop-types';

import ImportButton from './ImportButton';

import './Import.scss';

export default class SaveUsers extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    disabled: PropTypes.bool
  };

  state = {
    observer: null
  };

  render() {
    const { onSubmit, disabled } = this.props;

    return <ImportButton isDisabled={disabled} onClick={onSubmit} />;
  }
}
